import _extends from "@babel/runtime/helpers/extends";
import _jsx from "@babel/runtime/helpers/jsx";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["course", "streamingNow"];
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './LivestreamBadge.scss';
import messages from '../CourseDetailsHeader/coursedetailsHeaderMessages';
import formatLivestreamDate, { isSameDay } from '../../../helpers/formatLivestreamDate';
var LivestreamBadge = function LivestreamBadge(_ref) {
  var course = _ref.course,
    _ref$streamingNow = _ref.streamingNow,
    streamingNow = _ref$streamingNow === void 0 ? false : _ref$streamingNow,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (course.type !== 'livestream') {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", rest, streamingNow && /*#__PURE__*/_jsx("div", {
    className: s.livestreamStartBadge
  }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.streaming)), !streamingNow && /*#__PURE__*/_jsx("div", {
    className: s.livestreamStartBadge
  }, void 0, isSameDay(course.liveStreamStart, course.liveStreamEnd) && moment().isAfter(course.liveStreamEnd) ? /*#__PURE__*/_jsx("span", {}, void 0, formatLivestreamDate(course.liveStreamStart)) : /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.streamingStartAt, {
    values: formatLivestreamDate(course.liveStreamStart, course.liveStreamEnd, moment().isAfter(course.liveStreamEnd))
  }))));
};
export default withStyles(s)(LivestreamBadge);